import BaseDrawer from "@stardust/base-drawer";

class MobileFiltersDrawer extends BaseDrawer {
  constructor(element) {
    super(element, {
      openClass: 'opacity-0',
      closeClass: 'opacity-0',
    });
  }

  open() {
    super.open();
    const form = this.element.querySelector('[data-mobile-filters-form]');
    if (form) {
      requestAnimationFrame(() => form.classList.remove('translate-y-full'));
    }
    document.querySelectorAll('[aria-controls="MobileFiltersDrawer"]').forEach(el => el.setAttribute('aria-expanded', 'true'));
  }

  close() {
    const form = this.element.querySelector('[data-mobile-filters-form]');
    if (form) {
      let hasClosed = false;
      let fallbackTimeout;
      const finalizeClose = () => {
        if (hasClosed) return;
        hasClosed = true;
        clearTimeout(fallbackTimeout);
        form.removeEventListener('transitionend', onEnd);
        super.close();
      };
      form.classList.add('translate-y-full');
      const onEnd = (e) => {
        // Tailwind v4 emits translate utilities as the `translate` property, not `transform`.
        if (e.target !== form || !['transform', 'translate'].includes(e.propertyName)) return;
        finalizeClose();
      };
      form.addEventListener('transitionend', onEnd);
      fallbackTimeout = window.setTimeout(finalizeClose, 400);
    } else {
      super.close();
    }
    document.querySelectorAll('[aria-controls="MobileFiltersDrawer"]').forEach(el => el.setAttribute('aria-expanded', 'false'));
  }

  load() {
    // Listen for open/close events dispatched by theme.js event delegation.
    // Both use document-level listeners so they survive DOM morphs.
    document.addEventListener("mobile-filters:open", this._boundOpen);
    document.addEventListener("mobile-filters:close", this._boundClose);

    // Close when clicking the backdrop (the drawer element itself, not the form panel inside).
    this.element.addEventListener('click', (e) => {
      if (e.target === this.element) this.close();
    });

    // After a section morph, the server-rendered HTML resets the drawer's CSS
    // classes (adding back opacity-0, translate-y-full, pointer-events-none),
    // but this JS instance still has isOpen = true from the previous open().
    // Reset internal state so open() doesn't early-return next time.
    document.addEventListener('theme:section:morph', () => {
      this.isOpen = false;
    });

    // Allow SS (or any provider) to replace the drawer's inner content
    document.addEventListener('mobile-filters:set-content', (e) => {
      const contentArea = this.element?.querySelector('[data-mobile-filters-content]');
      if (contentArea && e.detail?.content) {
        contentArea.innerHTML = '';
        contentArea.appendChild(e.detail.content);
      }
    });
  }
}

// Initialize mobile filters drawer
const init = () => {
  const mobileFiltersDrawer = document.querySelector('[data-mobile-filters-drawer]');
  if (mobileFiltersDrawer) new MobileFiltersDrawer(mobileFiltersDrawer).load();
};
init();
